<div class="page-container">
    <div class="header-section">
        <lib-breadcrumb *ngIf="breadcrumbs" [list]="breadcrumbs"></lib-breadcrumb>
        <h2 class="page-title">{{ pageTitle }}</h2>
    </div>

    <!-- Search Criteria Panel -->
    <div class="content-wrapper">
        <form [formGroup]="searchForm" (ngSubmit)="handleSearch()" class="search-form-card">
            <div class="search-grid">
                <div class="form-item">
                    <mat-label>Username</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="userName" />
                        <div *ngIf="searchForm.get('userName')?.touched && searchForm.get('userName')?.errors">
                            <span *ngIf="searchForm.get('userName')?.errors?.['required']">
                                Username is required
                            </span>

                            <span *ngIf="searchForm.get('userName')?.errors?.['specialChars']">
                                Special characters are not allowed
                            </span>
                            </div>
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button type="reset" mat-stroked-button color="primary" [disabled]="isLoading"
                        (click)="handleFormReset()">Reset</button>
                    <button type="submit" mat-flat-button color="primary"
                        [disabled]="searchForm.invalid || isLoading">Force Log Off</button>
                </div>
            </div>
        </form>

    </div>
</div>
